<form [formGroup]="tenantchangeForm">
  <kendo-dialog class="tenant-selection-modal" title="{{'_Shared_App_TenantChange_Change_Client_Text_' | translate}}" *ngIf="dialogOpened" (close)="close()" [minWidth]="300" [width]="500">
    <kendo-dialog-messages closeTitle="{{'_General_Button_Close_Text_' | translate }}"></kendo-dialog-messages>
    <div class="tenant-selection">
      <label>{{'_Shared_App_TenantChange_Select_Client_Text_' | translate }}</label>
      <select class="cc-select-dropdown form-control" formControlName="tenant">
        <!-- <option value="">Select</option> -->
        <option *ngFor="let tenant of availableTenants; trackBy:tenantTrackBy" [ngValue]="tenant.tenantID"
          [selected]="tenant.tenantID === selectedTenant.tenantID">
          {{tenant.tenantDisplayName}}
        </option>
      </select>
    </div>
    <div class="tenant-token">
      <label>{{'_Shared_App_TenantChange_Ticket_Number_Text_' | translate }}</label>
      <input formControlName="token" class="form-control">
      <div *ngIf="tokenField?.invalid && (tokenField?.dirty || tokenField?.touched)">
        <div class="cc-validation" *ngIf="tokenField?.errors?.required">
          {{'_Shared_App_TenantChange_Ticket_Number_Required_Text_' | translate }}
        </div>
      </div>
    </div>
    <kendo-dialog-actions class="cc-btn-panel">
      <button type="button" class="btn btn-secondary" (click)="close()">{{'_General_Button_Cancel_Text_' | translate }}</button>
      <button type="button" class="btn btn-primary" (click)="onSaveClicked()" [disabled]="!tenantchangeForm.valid" type="submit">
        {{'_Shared_App_TenantChange_Change_Client_Text_' | translate }}
      </button>
    </kendo-dialog-actions>
  </kendo-dialog>
</form>
